import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { getHolidayList, updateHolidayfo } from '@/services/systemsetting/holiday';
import CalMonth from "./CalMonth.vue";
import Vue from 'vue';
export default {
  name: "Holidayset",
  i18n: require('./i18n-holiday'),
  components: {
    CalMonth: CalMonth
  },
  data: function data() {
    return {
      spinning: false,
      radio: '',
      checked: true,
      type: '',
      storeId: '',
      year: 0,
      months: [],
      holiday: [],
      loading: false,
      //调接口加载数据中时使用
      sysholiday: 0,
      //系统设置的节假日 周六周日是否为工作日 0初始没有设置
      updateHolidayfoLoading: false
    };
  },
  mounted: function mounted() {
    this.getStoreHoliday();
    var today = new Date();
    this.months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    this.year = today.getFullYear();
  },
  activated: function activated() {
    this.getStoreHoliday();
  },
  methods: {
    // openFullScreen() {
    //    let self = this;
    //       self.loading = self.$loading({
    //          lock: true,
    //          text: '',
    //          spinner: 'el-icon-loading',
    //          background: 'rgba(0, 0, 0, 0.7)'
    //        });
    //    },
    // closeFullScreen() {
    // 	let self = this;
    // 	self.loading.close();
    // },
    /* 获取当前商家的节假日 */
    getStoreHoliday: function getStoreHoliday() {
      var _this = this;
      this.spinning = true;
      // this.openFullScreen();
      getHolidayList().then(function (response) {
        if (response.data.code == 200) {
          _this.spinning = false;
          _this.holiday = response.data.data.list;
          _this.storeId = response.data.data.id;
          /* 1：周六日为休息日 2：周六日为工作日 */
          if (response.data.data.storeHoliday == 1) {
            _this.radio = 1;
            _this.checked = true;
            _this.type = 1;
          } else {
            _this.radio = 2;
            _this.checked = false;
            _this.type = 2;
          }
        }
        _this.spinning = false;
      });
    },
    /* 更新商家周六日,是否为休息日的状态 */updateHoliday: function updateHoliday(e) {
      this.radio = e.target.value;
      console.log(e.target.value);
      // console.log(this.radio=='0')
      //this.radio  1 休息日  2 工作日  0也是工作日
      if (this.radio == 1) {
        this.checked = true;
      } else if (this.radio == 2 || this.radio == 0) {
        this.checked = false;
      }
      //storeId  type  year
      if (this.checked) {
        this.type = 1;
      } else {
        this.type = 2;
      }
    },
    previousyear: function previousyear() {
      this.year = this.year - 1;
    },
    nextyear: function nextyear() {
      this.year = this.year + 1;
    },
    changeDays: function changeDays(e) {
      var date = e.date;
      var istoday = e.is_today;
      var day = new Date(date);
      var template;
      //是istoday=1 说明是工作日
      if (istoday == 1) {
        template = {
          holidayState: 1,
          holidayDate: date,
          isSunday: 0
        };
        //如果是周末的话,就要isSunday赋值为1
        if (day.getDay() == 6 || day.getDay() == 0) {
          template.isSunday = 1;
        }
      } else if (istoday == 0) {
        template = {
          holidayState: 0,
          holidayDate: date,
          isSunday: 0
        };
        if (day.getDay() == 6 || day.getDay() == 0) {
          template.isSunday = 1;
        }
      }
      var exits = _.find(this.holiday, function (o) {
        return o.holidayDate == template.holidayDate;
      });
      if (exits) {
        exits.holidayState = template.holidayState;
      } else {
        this.holiday.push(template);
      }
      console.log(this.holiday);
    },
    savehoilday: function savehoilday() {
      var _this2 = this;
      // 保存商家状态
      if (this.holiday.length > 0 || this.type != 0) {
        var param = {
          type: this.type === '' ? 1 : this.type,
          dayHolidayDtoList: this.holiday
        };
        if (this.updateHolidayfoLoading) return;
        this.updateHolidayfoLoading = true;
        updateHolidayfo(param).then(function (response) {
          _this2.getStoreHoliday();
          _this2.$message.success(_this2.$t('public.updateSuccessfully'));
        }).finally(function () {
          _this2.updateHolidayfoLoading = false;
        });
      }
    }
  }
};